import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './ConsentForm.module.scss';
import CheckBox from '../../../../Form/Preference/CheckBox/CheckBox';

function ConsentForm({ consent, setConsent, revoke }) {
  const { t } = useTranslation();
  return (
    <div className={`d-flex flex-column ${styles.ConsentForm}`}>
      <div className={styles.title}>{t('dashboard.profile.consent.manage')}</div>
      <div className={styles.checkboxes}>
        <CheckBox
          selected={consent}
          label={t('dashboard.profile.consent.marketing')}
          onChange={(e) => revoke(e.target.checked)}
        />
      </div>
      <Link data-testid="link" to="/my-profile/rtbf" className={styles.request} aria-hidden="true">
        <p>{t('dashboard.profile.consent.forgotten')}</p>
      </Link>
    </div>
  );
}

export default ConsentForm;
